const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const ProductPomMeasurementQueryURL: any = {
    GetByBarcode: (barcode: string) =>
        `${Backofficebff}/v1/product-pom-measurements?barcode=${encodeURIComponent(barcode)}`,
};
